"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OperationsLeftOutContext = void 0;
var _react = _interopRequireDefault(require("react"));
var _lucideReact = require("lucide-react");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function leftOutLabelOf(operationsLeftOut) {
  return operationsLeftOut.length === 1 ? "1 edit the agent asked for is not in this card." : "".concat(operationsLeftOut.length, " edits the agent asked for are not in this card.");
}
var OperationsLeftOutContext = exports.OperationsLeftOutContext = function OperationsLeftOutContext(_ref) {
  var operationsLeftOut = _ref.operationsLeftOut;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    role: "status",
    "data-testid": "operations-left-out",
    title: operationsLeftOut.map(function (leftOut) {
      return leftOut.message;
    }).join("\n"),
    className: "flex items-start gap-1 text-[11px] leading-[16px] text-[#B45309]",
    "data-sentry-component": "OperationsLeftOutContext",
    "data-sentry-source-file": "OperationsLeftOutContext.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_lucideReact.AlertTriangle, {
      size: 14,
      className: "mt-px flex-shrink-0 text-[#F59E0B]",
      "aria-hidden": "true",
      "data-sentry-element": "AlertTriangle",
      "data-sentry-source-file": "OperationsLeftOutContext.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "min-w-0",
      children: leftOutLabelOf(operationsLeftOut)
    })]
  });
};